export default class UnknownError extends Error {
	public constructor() {
		super();
	}
}
